module.exports = __webpack_public_path__ + "static/assets/17b88b2ece805466696817805841c83c.png";